import { countryCodeValues } from '@borradh-workspace/labels';
import { z } from 'zod';
export const placePredictionSchema = z.object({
    placeId: z.string(),
    description: z.string(),
    mainText: z.string(),
    secondaryText: z.string(),
});
export const searchPlacesResponseSchema = z.object({
    predictions: z.array(placePredictionSchema),
});
/** A selected search result, with the same normalized address as Maps links. */
export const placeDetailsResponseSchema = z.object({
    placeId: z.string(),
    name: z.string(),
    formattedAddress: z.string(),
    addressLine1: z.string(),
    addressLine2: z.string(),
    city: z.string(),
    county: z.string(),
    postalCode: z.string(),
    country: z.enum(countryCodeValues).nullable(),
    latitude: z.number(),
    longitude: z.number(),
    isBusiness: z.boolean(),
});
//# sourceMappingURL=places.js.map